export default __webpack_public_path__ + "static/media/terminoliesIcon.3c9ec559.svg";